var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"height":_vm.height,"width":_vm.width,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }